import { Link } from "react-router-dom";
import useSEO from "@/lib/useSEO";
import Nav from "@/sections/Nav";
import Footer from "@/sections/Footer";

export default function NotFound() {
  useSEO({
    title: "Page not found",
    description: "This page doesn't exist. Browse Planet Air Adventure's private Bhutan tour packages instead.",
    noindex: true,
  });
  return (
    <div className="App relative">
      <Nav />
      <main className="min-h-[70vh] flex items-center">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-40">
          <div className="text-[11px] uppercase tracking-[0.3em] text-foreground/60 mb-6">404</div>
          <h1 className="font-serif font-light text-5xl md:text-7xl leading-[0.94] tracking-tighter">
            This trail <em className="italic text-primary">doesn't exist.</em>
          </h1>
          <p className="mt-6 text-base text-foreground/65 max-w-md font-light leading-relaxed">
            The page you were looking for has moved or never existed.
          </p>
          <div className="mt-10 flex gap-6 text-[11px] uppercase tracking-[0.22em] font-medium">
            <Link to="/journeys" className="border border-foreground/80 px-6 py-3 btn-sharp">All Bhutan journeys →</Link>
            <Link to="/" className="py-3 hover:text-primary transition-colors">Home</Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
